import { render, staticRenderFns } from "./SwCalendarNavigation.vue?vue&type=template&id=23a589b3"
import script from "./SwCalendarNavigation.vue?vue&type=script&lang=js"
export * from "./SwCalendarNavigation.vue?vue&type=script&lang=js"
import style0 from "./SwCalendarNavigation.vue?vue&type=style&index=0&id=23a589b3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports